<template>
  <w-icon-wrapper
    :width='20'
    :height='20'
    icon-name='work-nav-search-icon'
    view-box='0 0 20 20'
  >
    <path
      id="_20_Suche_Icon"
      data-name="20_Suche_Icon"
      d="M138.444-820l-7-7a6.607,6.607,0,0,1-1.917,1.057,6.8,6.8,0,0,1-2.306.388,6.975,6.975,0,0,1-5.125-2.1,6.975,6.975,0,0,1-2.1-5.125,6.976,6.976,0,0,1,2.1-5.127,6.974,6.974,0,0,1,5.125-2.1,6.975,6.975,0,0,1,5.125,2.1,6.977,6.977,0,0,1,2.1,5.127,6.774,6.774,0,0,1-.389,2.3A6.631,6.631,0,0,1,133-828.555l7,7Zm-11.222-7.777a4.818,4.818,0,0,0,3.542-1.459,4.816,4.816,0,0,0,1.458-3.54,4.829,4.829,0,0,0-1.458-3.544,4.825,4.825,0,0,0-3.542-1.457,4.825,4.825,0,0,0-3.542,1.457,4.83,4.83,0,0,0-1.458,3.544,4.817,4.817,0,0,0,1.458,3.54A4.818,4.818,0,0,0,127.222-827.777Z"
      transform="translate(-120 840)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavSearch' };
</script>

